import { IconButton, type IconButtonProps } from '@mui/material';

type FilledIconButtonProps = Omit<IconButtonProps, 'color'>;

export default function FilledIconButton({ children, ...props }: FilledIconButtonProps) {
  return (
    <IconButton
      {...props}
      sx={{
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        '&:hover': { bgcolor: 'primary.dark' },
      }}
    >
      {children}
    </IconButton>
  );
}
